import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "../../../components/UI/Customstrap/Customstrap";
import { Label } from "reactstrap";
import { getSavedPersonInfo, getNotifications } from "../../../reducers/selectors";
import style from "./PepOnboarding.scss";
import { HeaderOnboarding } from "../HeaderOnboarding/HeaderOnboarding";
import GenericButton from "../../../components/UI/Button/Button";
import { WelcomeOnboarding } from "../WelcomeOnboarding/WelcomeOnboarding";
import confirmIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import { updatePersonClientData } from "../../../services/api/person";
import { confirmFirstAccess } from "../../../services/api/internalMessages";
import { showToast } from "../../../utils/helper";
import MediaQuery from "react-responsive";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";

export const PepOnboarding = ({ toggleMobileSidebar }) => {
  const personInfo = useSelector(getSavedPersonInfo);
  const notifications = useSelector(getNotifications);
  const [showWelcome, setShowWelcome] = useState(false);
  const [padding, setPadding] = useState("8px 46px");
  const [loadingButtons, setLoadingButtons] = useState(false);

  //controls button padding according to the screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 320 && window.innerWidth <= 390) {
        setPadding("8px 2px");
      } else if (window.innerWidth >= 390 && window.innerWidth <= 724) {
        setPadding("8px 12px");
      } else {
        setPadding("8px 46px");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const firstAccess = () => {
    confirmFirstAccess({
      read: false,
      approved: true,
      InternalMessageId: notifications[0].InternalMessageId,
      LegalContractId: 0,
      ContractDocumentIds: [],
    })
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error confirmando el primer acceso", true);
        } else {
          showToast("Información enviada correctamente");
        }
      })
      .catch((err) => {
        showToast("Error confirmando el primer acceso", true);
        console.error(err);
      });
  };

  const toggleShowWelcomeIsPep = () => {
    setLoadingButtons(() => true);
    const personUpdate = {
      PhysicalPersonPublicPositionId: 2,
      PhysicalPersonPublicPositionName: "SI",
    };

    updatePersonClientData(personUpdate)
      .then(({ response }) => {
        if (response.result.Code === 200) {
          firstAccess();
          setShowWelcome(true);
        } else {
          alert("Problemas editando persona");
          setLoadingButtons(() => false);
        }
      })
      .catch((err) => {
        console.error("Error updating person:", err);
        setLoadingButtons(() => false);
      });
  };

  const toggleShowWelcomeNotPep = () => {
    setLoadingButtons(() => true);
    const personUpdate = {
      PhysicalPersonPublicPositionId: 1,
      PhysicalPersonPublicPositionName: "NO",
    };

    updatePersonClientData(personUpdate)
      .then(({ response }) => {
        if (response.result.Code === 200) {
          firstAccess();
          setShowWelcome(true);
        } else {
          alert("Problemas editando persona");
          setLoadingButtons(() => false);
        }
      })
      .catch((err) => {
        console.error("Error updating person:", err);
        setLoadingButtons(() => false);
      });
  };

  return (
    <div className={style.containerData}>
      <HeaderOnboarding title={<span>Declaración PEP</span>} toggleMobileSidebar={toggleMobileSidebar} />
      <Row className={style.headerTitle}>
        <Label>Declaración PEP</Label>
        <MediaQuery maxWidth={576}>
          <div className={style.divider}></div>
        </MediaQuery>
      </Row>
      <Row className={style.dataRow}>
        <Col>
          <div className={style.blankSpace}></div>
          <div className={style.dataTitle}>¿Qué es una Persona Expuesta Políticamente (PEP)?</div>
          <div className={style.data}>
            Es una persona que ocupa cargos de suma importancia como presidente, senador o diputado, ya sea en
            nuestro país o en el extranjero.
          </div>
          <div className={style.blankSpace}></div>
          <div className={style.dataTitle}>¿Por qué te pedimos este dato?</div>
          <div className={style.data}>
            Si vos o alguien de tu familia ocupa un cargo político, necesitaremos más información para abrir
            tu cuenta.
          </div>
          <div className={style.blankSpace}></div>
          <div className={style.divider}></div>
          <div className={style.buttonContainer}>
            <MediaQuery maxWidth={576}>
              <GenericButton
                label={"Soy PEP"}
                disabled={loadingButtons}
                rounded
                padding={padding}
                secondary
                right
                width={"100%"}
                handleClick={toggleShowWelcomeIsPep}
              />
              <GenericButton
                label={"No soy PEP"}
                disabled={loadingButtons}
                rounded
                padding={padding}
                primary
                right
                width={"100%"}
                handleClick={toggleShowWelcomeNotPep}
              />
              {loadingButtons && (
                <div>
                  <CircularProgress />
                </div>
              )}
            </MediaQuery>
            <MediaQuery minWidth={577}>
              <GenericButton
                label={"Soy PEP"}
                disabled={loadingButtons}
                rounded
                padding={padding}
                secondary
                right
                //width={"100%"}
                handleClick={toggleShowWelcomeIsPep}
                iconSvg={[{ width: "16px", item: confirmIcon }]}
              />
              <GenericButton
                label={"No soy PEP"}
                disabled={loadingButtons}
                rounded
                padding={padding}
                primary
                right
                //marginLeft={"20px"}
                //width={"100%"}
                handleClick={toggleShowWelcomeNotPep}
                iconSvg={[{ width: "16px", item: confirmIcon }]}
              />
              {loadingButtons && <CircularProgress />}
            </MediaQuery>
          </div>
        </Col>
      </Row>
      {showWelcome && <WelcomeOnboarding />}
    </div>
  );
};
